import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title gap-5" }
const _hoisted_4 = { class: "card-body py-4" }
const _hoisted_5 = {
  class: "table align-middle table-row-dashed fs-6 gy-5 table-hover",
  id: "table_accounts_requests"
}
const _hoisted_6 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", { class: "" }, "UTM", -1)
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 2,
  class: "fw-semibold text-gray-600"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "d-md-flex align-items-center" }
const _hoisted_22 = {
  key: 0,
  class: "fa-solid fa-check fa-xl",
  style: {"color":"#4ed06e"}
}
const _hoisted_23 = {
  key: 1,
  class: "fa-solid fa-xmark fa-xl",
  style: {"color":"#d92626"}
}
const _hoisted_24 = ["onClick"]

import { ref, onMounted, inject } from "vue";
import UserService from "../../services/UserService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import LeadDetailsModal from "./LeadDetailsModal.vue";
import { Search } from "@element-plus/icons-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UtmIndex',
  setup(__props) {

const isLoading = inject<any>("isLoading");
const data = ref<any>([]);
const accountSelected = ref(0);
const leadDetailsModalRef = ref<InstanceType<typeof LeadDetailsModal>>();
const selectedLeads = ref(Array<any>());

const utms = ref<any>([]);

const criteria = ref<any>({
  page: 1,
  size: 20,
  hasUtm: true,
});

const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  try {
    criteria.value.utms =
      utms.value.length !== 0
        ? utms.value.split(",").map((item) => item.trim())
        : null;
    const res = await UserService.queryRepLeads(criteria.value);
    data.value = res.data;
    criteria.value = res.criteria;
  } catch (e) {
    MsgPrompt.error(e);
  } finally {
    isLoading.value = false;
  }
};

const reset = async () => {
  criteria.value = {
    page: 1,
    size: 20,
  };
  utms.value = [];
  await fetchData(1);
};

const assignSalesSuccess = () => {
  selectedLeads.value = [];
  fetchData(1);
};

const openLeadDetailsModal = (_lead) => {
  leadDetailsModalRef.value?.show(_lead);
};

const selectedAccount = (id: number) => {
  accountSelected.value = id;
};

onMounted(async () => {
  await fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_UserAvatar = _resolveComponent("UserAvatar")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_input, {
            modelValue: criteria.value.keyword,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria.value.keyword) = $event)),
            placeholder: "Keyword (Email / Name / PhoneNumber)",
            clearable: "",
            class: "w-350px"
          }, {
            append: _withCtx(() => [
              _createVNode(_component_el_button, {
                icon: _unref(Search),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (fetchData(1))),
                loading: _unref(isLoading)
              }, null, 8, ["icon", "loading"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_input, {
            modelValue: utms.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((utms).value = $event)),
            placeholder: "UTM (separated by commas)",
            clearable: "",
            class: "w-250px"
          }, {
            append: _withCtx(() => [
              _createVNode(_component_el_button, {
                icon: _unref(Search),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (fetchData(1))),
                loading: _unref(isLoading)
              }, null, 8, ["icon", "loading"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_select, {
            modelValue: criteria.value.isAssigned,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((criteria.value.isAssigned) = $event)),
            placeholder: "Is Assigned",
            clearable: "",
            onChange: _cache[5] || (_cache[5] = ($event: any) => (fetchData(1))),
            disabled: _unref(isLoading)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                value: true,
                label: _ctx.$t('fields.yes')
              }, null, 8, ["label"]),
              _createVNode(_component_el_option, {
                value: false,
                label: _ctx.$t('fields.no')
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_select, {
            modelValue: criteria.value.hasTradeAccount,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((criteria.value.hasTradeAccount) = $event)),
            placeholder: "Has Trade Account",
            clearable: "",
            onChange: _cache[7] || (_cache[7] = ($event: any) => (fetchData(1))),
            disabled: _unref(isLoading)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                value: true,
                label: _ctx.$t('fields.yes')
              }, null, 8, ["label"]),
              _createVNode(_component_el_option, {
                value: false,
                label: _ctx.$t('fields.no')
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_select, {
            modelValue: criteria.value.hasDeposit,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((criteria.value.hasDeposit) = $event)),
            placeholder: "Has Deposit",
            clearable: "",
            onChange: _cache[9] || (_cache[9] = ($event: any) => (fetchData(1))),
            disabled: _unref(isLoading)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                value: true,
                label: _ctx.$t('fields.yes')
              }, null, 8, ["label"]),
              _createVNode(_component_el_option, {
                value: false,
                label: _ctx.$t('fields.no')
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_select, {
            modelValue: criteria.value.isConverted,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((criteria.value.isConverted) = $event)),
            placeholder: "Is Converted",
            clearable: "",
            onChange: _cache[11] || (_cache[11] = ($event: any) => (fetchData(1))),
            disabled: _unref(isLoading)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                value: true,
                label: _ctx.$t('fields.yes')
              }, null, 8, ["label"]),
              _createVNode(_component_el_option, {
                value: false,
                label: _ctx.$t('fields.no')
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _createVNode(_component_el_button, {
          disabled: _unref(isLoading),
          onClick: reset,
          class: "me-5"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.reset")), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("table", _hoisted_5, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_6, [
            _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("fields.user")), 1),
            _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("fields.email")), 1),
            _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("fields.phone")), 1),
            _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("fields.source")), 1),
            _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("fields.status")), 1),
            _hoisted_12,
            _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("fields.hasAssigned")), 1),
            _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
            _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t("fields.updatedOn")), 1),
            _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t("fields.action")), 1)
          ])
        ]),
        (_unref(isLoading))
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_17, [
              _createVNode(_component_LoadingRing)
            ]))
          : (!_unref(isLoading) && data.value.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_18, [
                _createVNode(_component_NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    class: _normalizeClass({
              'tr-select': item.id === accountSelected.value,
            }),
                    onClick: ($event: any) => (selectedAccount(item.id))
                  }, [
                    _createElementVNode("td", _hoisted_21, [
                      _createVNode(_component_UserAvatar, {
                        avatar: item.user?.avatar ?? '',
                        name: item.user?.displayName || item.name,
                        size: "40px",
                        class: "me-3",
                        side: "client",
                        rounded: ""
                      }, null, 8, ["avatar", "name"]),
                      _createElementVNode("span", null, _toDisplayString(item.user?.nativeName || item.user?.displayName || item.name), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.email), 1),
                    _createElementVNode("td", null, _toDisplayString(item.phoneNumber), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.leadSource.${item.sourceType}`)), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.leadStatus.${item.status}`)), 1),
                    _createElementVNode("td", null, _toDisplayString(item.utm), 1),
                    _createElementVNode("td", null, [
                      (item.hasAssignedToSales)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_22))
                        : (_openBlock(), _createElementBlock("i", _hoisted_23))
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_TimeShow, {
                        type: "inFields",
                        "date-iso-string": item.createdOn
                      }, null, 8, ["date-iso-string"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_TimeShow, {
                        type: "inFields",
                        "date-iso-string": item.updatedOn
                      }, null, 8, ["date-iso-string"])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: "cursor-pointer",
                        style: {"color":"#7c8fa2"},
                        onClick: ($event: any) => (openLeadDetailsModal(item))
                      }, _toDisplayString(_ctx.$t("action.showDetails")), 9, _hoisted_24)
                    ])
                  ], 10, _hoisted_20))
                }), 128))
              ]))
      ]),
      _createVNode(_component_TableFooter, {
        onPageChange: fetchData,
        criteria: criteria.value
      }, null, 8, ["criteria"])
    ]),
    _createVNode(LeadDetailsModal, {
      ref_key: "leadDetailsModalRef",
      ref: leadDetailsModalRef,
      onUpdate: assignSalesSuccess
    }, null, 512)
  ]))
}
}

})